import { useParams } from 'react-router-dom';

export default function PlaceholderPage() {
  const params = useParams();
  const name = params['*'] || 'Page';
  const title = name
    .split('/')
    .filter(Boolean)
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(' / ');

  return (
    <main className="max-w-7xl mx-auto px-4 py-12">
      <h1 className="text-2xl font-bold text-[var(--foreground)] mb-4">
        {title}
      </h1>
      <p className="text-gray-500">This page is under construction.</p>
    </main>
  );
}
